import { capturarErro } from "analytics/posthogClient";

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

/**
 * Logger do app.
 *
 * `warn` e `error` escrevem no console em qualquer ambiente e, fora de
 * localhost, também vão para o PostHog. Os handlers globais do PostHog só pegam
 * erro não tratado; sem este encaminhamento, todo `logger.error` de um `catch`
 * (falha de token, de upload, de pagamento) ficaria invisível em produção.
 *
 * Os níveis verbosos seguem restritos a localhost para não poluir o console do
 * usuário final.
 *
 * @param {"error"|"warning"} nivel
 * @param {any[]} args - o primeiro Error encontrado vira a exceção; o restante
 *   entra como contexto.
 */
const reportar = (nivel, args) => {
  // Serializar valor arbitrário pode lançar (um `toString` que explode, por
  // exemplo). O logger é chamado de dentro de `catch`: se ele próprio lançar,
  // derruba o tratamento de erro de quem chamou.
  try {
    const erro = args.find((a) => a instanceof Error);
    const descritos = args.map(descrever);
    capturarErro(erro ?? descritos.join(" "), {
      level: nivel,
      arguments: descritos,
    });
  } catch {
    // Observabilidade nunca deve quebrar o fluxo do app.
  }
};

const descrever = (valor) => {
  if (valor instanceof Error) {
    return { name: valor.name, message: valor.message, stack: valor.stack };
  }
  if (typeof valor === "object" && valor !== null) {
    try {
      return JSON.parse(JSON.stringify(valor));
    } catch {
      return String(valor);
    }
  }
  return valor;
};

const logger = {
  log: (...args) => isLocalhost && console.log(...args),
  warn: (...args) => {
    console.warn(...args);
    if (!isLocalhost) reportar("warning", args);
  },
  error: (...args) => {
    console.error(...args);
    if (!isLocalhost) reportar("error", args);
  },
  info: (...args) => isLocalhost && console.info(...args),
  debug: (...args) => isLocalhost && console.debug(...args),
  group: (...args) => isLocalhost && console.group(...args),
  groupEnd: () => isLocalhost && console.groupEnd(),
  table: (...args) => isLocalhost && console.table(...args),
};

export default logger;
